import clsx from "clsx";
import { Ambulance } from "lucide-react";

const STYLES = {
  "01": "bg-[#E62E2E] text-white",
  "02": "bg-[#E67300] text-black",
  "03": "bg-[#2E5CE6] text-white",
  "04": "bg-[#7C2BE6] text-white",
  "00": "bg-white text-black border border-black",
  "99": "bg-zinc-100 text-black border border-zinc-400",
};

const SHORT = {
  "01": "Fatal",
  "02": "Serious",
  "03": "Minor",
  "04": "Possible",
  "00": "None",
  "99": "Unknown",
};

export default function InjuryBadge({ code, transported }) {
  const c = (code || "").trim();
  const showAmb = transported && (c === "04" || c === "01" || c === "02" || c === "03");
  return (
    <span
      data-testid={`injury-badge-${c || "na"}`}
      className={clsx(
        "inline-flex items-center gap-1 px-2 py-[3px] font-mono text-[11px] font-bold tracking-tight uppercase",
        STYLES[c] || "bg-zinc-100 border border-zinc-400"
      )}
    >
      <span className="opacity-80">{c || "--"}</span>
      <span className="opacity-90">{SHORT[c] || ""}</span>
      {showAmb && (
        <Ambulance
          className="w-3 h-3 ml-0.5"
          strokeWidth={2.5}
          aria-label="Transported to hospital"
        />
      )}
    </span>
  );
}
